var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapVertDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10L0 5.45455L1.2825 4.18182L3.6 6.52273V0H5.4V6.52273L7.7175 4.18182L9 5.45455L4.5 10Z",
    fill: "#6021B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVertDown);
export default __webpack_public_path__ + "static/media/swap_vert_down.68d567a4353d01c7e75fb35c277e8953.svg";
export { ForwardRef as ReactComponent };